import React from "react";
import { cn } from "@/lib/utils";
import { YesNo, area, field } from "@/components/canvas/risiko/bits";
import { money } from "@/lib/sk";

/** Header facts come from the case/calculation (read-only); the seven source questions are answered Ja/Nei – never pre-filled. */
export function RisikoChecklist({ draft, meta, project, terskel, onChange }) {
  const cl = draft.checklist || {};
  const setQ = (key, patch) => onChange({ ...draft, checklist: { ...cl, [key]: { ...(cl[key] || {}), ...patch } } });
  const setF = (key, v) => onChange({ ...draft, fields: { ...(draft.fields || {}), [key]: v } });
  const facts = [
    ["Tilbudsnummer", project.number || "–"],
    ["Navn på båt", project.vessel?.name || "–"],
    ["Navn på kunde", project.customer?.name || "–"],
    ["Omsetning (kalkylens sum eks. mva)", terskel?.sum_kind === "complete" ? `${money(terskel.sum, "NOK", 1, { bare: true })} NOK` : terskel?.sum_kind === "preliminary" ? `foreløpig ${money(terskel.sum, "NOK", 1, { bare: true })} NOK – ufullstendig` : "ikke beregnet"],
  ];
  return (
    <div className="space-y-5" data-testid="risiko-checklist">
      <div className="grid gap-x-5 gap-y-2 sm:grid-cols-2" data-testid="risiko-case-facts">
        {facts.map(([l, v]) => <div key={l} className="min-w-0"><div className="text-[11px] font-medium text-muted-foreground">{l}</div><div className="truncate text-[13px]" title={String(v)}>{v}</div></div>)}
      </div>
      <div className="grid gap-x-5 gap-y-2.5 sm:grid-cols-2">
        {meta.fields.map((f) => (
          <div key={f.key} className={cn("min-w-0", f.kind === "text" && ["arbeid", "omsetning_note"].includes(f.key) && "sm:col-span-2")}>
            <label className="text-[11px] font-medium text-muted-foreground" htmlFor={`risiko-field-${f.key}`}>{f.label}</label>
            {f.kind === "date"
              ? <input id={`risiko-field-${f.key}`} type="date" value={draft.fields?.[f.key] || ""} onChange={(e) => setF(f.key, e.target.value)} className={cn(field, "mt-0.5")} data-testid={`risiko-field-${f.key}`} />
              : f.key === "arbeid"
                ? <textarea id={`risiko-field-${f.key}`} value={draft.fields?.[f.key] || ""} onChange={(e) => setF(f.key, e.target.value)} className={cn(area, "mt-0.5")} data-testid={`risiko-field-${f.key}`} />
                : <input id={`risiko-field-${f.key}`} value={draft.fields?.[f.key] || ""} onChange={(e) => setF(f.key, e.target.value)} className={cn(field, "mt-0.5")} data-testid={`risiko-field-${f.key}`} />}
            {f.hint ? <p className="mt-0.5 text-[10.5px] text-muted-foreground/80">{f.hint}</p> : null}
          </div>
        ))}
      </div>
      <div>
        <div className="mb-1.5 flex items-center justify-between text-[11px] font-medium text-muted-foreground"><span>Sjekkliste</span><span className="font-mono tabular-nums" data-testid="risiko-questions-count">{meta.questions.filter((q) => ["ja", "nei"].includes(cl[q.key]?.answer)).length}/{meta.questions.length} besvart</span></div>
        <ul className="divide-y divide-black/[0.05] rounded-[12px] border border-black/[0.06] bg-white">
          {meta.questions.map((q) => {
            const a = cl[q.key] || {};
            return (
              <li key={q.key} className="flex flex-wrap items-start gap-x-3 gap-y-1.5 px-3 py-2" data-testid={`risiko-q-${q.key}`} data-answer={a.answer || "none"}>
                <div className="min-w-[200px] flex-1 text-[13px]">{q.label}{!a.answer ? <span className="ml-2 text-[11px] text-[hsl(var(--v-assumed))]">ubesvart</span> : null}</div>
                <YesNo value={a.answer ?? null} onChange={(v) => setQ(q.key, { answer: v })} testId={`risiko-q-${q.key}-answer`} />
                <input value={a.comment || ""} onChange={(e) => setQ(q.key, { comment: e.target.value })} placeholder="Kommentar" className={cn(field, "h-7 w-full sm:w-[260px]")} data-testid={`risiko-q-${q.key}-comment`} />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
